import type { Item } from '@/entities/item/schemas/item';
import { numberToInput } from '@/shared/components/form/number-to-input';
import { centsToInput } from '@/shared/lib/money/cents-to-input';
import type { ItemFormValues } from '../schemas/item-form-values';

export function toItemForm(item?: Item): ItemFormValues {
  return {
    name: item?.name ?? '',
    category: item?.category ?? 'other',
    brand: item?.brand ?? '',
    quantity: numberToInput(item?.quantity ?? 1),
    unit: item?.unit ?? 'ud',
    min_quantity: numberToInput(item?.min_quantity),
    location: item?.location ?? '',
    tags: (item?.tags ?? []).join(', '),
    price: centsToInput(item?.price_cents),
    store: item?.store ?? '',
    url: item?.url ?? '',
    purchased_on: item?.purchased_on ?? '',
    expires_on: item?.expires_on ?? '',
    best_before: item?.best_before ?? '',
    replace_on: item?.replace_on ?? '',
    shelf_life_months: numberToInput(item?.shelf_life_months),
    active_ingredient: item?.active_ingredient ?? '',
    dosage: item?.dosage ?? '',
    notes: item?.notes ?? '',
    attachments: item?.attachments ?? [],
  };
}
